import React from "react";
import LocationHeading from "../../../shared/LocationHeading";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import oneImg from "../../../assets/Images/one.png";
import rightIcon from "../../../assets/Images/right_icon.png";
import profile from "../../../assets/Images/profile.png";
import mailIcon from "../../../assets/Images/mail_icon.svg";
import callIcon from "../../../assets/Images/call_icon.svg";
import proIcon from "../../../assets/Images/pro.svg";
import addressIcon from "../../../assets/Images/address.svg";
import pinIcon from "../../../assets/Images/pin.svg";

const LockedPlotDetails = () => {
  return (
    <>
      <div className="location_list">
        {" "}
        <LocationHeading
          title={[
            <Link to="">
              <i
                style={{
                  color: "#000",
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
                className="fa fa-long-arrow-left me-2"
                aria-hidden="true"
              ></i>
            </Link>,
            "Locked Plots Detail",
          ]}
        />
        <div className="blog-info-main locked-info-main p-2">
          <Container className="mt-4">
            <Row>
              <Col lg="8" className="left-side p-3">
                <Row>
                  <Col lg="4">
                    <div className="details-img locked-details-main-img">
                      <div class="view-img ">
                        <div className="main_image ">
                          <img src={oneImg} alt="" />
                        </div>
                        <div class="selectable-img">
                          <ul>
                            <li className={""}>
                              <img src={oneImg} alt="image" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg="8">
                    <div class="about-location locked-details-location">
                      <div class="about-location-head">
                        <div class="about-heading">
                          <h3 className="d-flex align-center gap-2">
                            Kendal{" "}
                            <button className="status_button draft">
                              Pending
                            </button>
                          </h3>
                          <span>
                            <b>Order ID:</b> 125468
                          </span>
                          <span className="mx-2 dot_span"></span>
                          <span>
                            <b>Created on:</b> 25 July, 2025 8:12 PM
                          </span>
                        </div>
                        <div class="location-edit">
                          <button className="mark-btn">
                            <img src={rightIcon} alt="icon" /> Mark as complete
                          </button>
                        </div>
                      </div>
                      <div class="about-price">
                        <span>££1,375</span>
                      </div>
                      <div class="about-discription">
                        <p className="text-muted">
                          This spellbinding location in the south of the Lake
                          District is held dear in the hearts of many visitors
                          who find Kendal and its surrounding countryside one of
                          the most uplifting and inspiring places on earth.
                        </p>
                      </div>
                      <div class="about-sizes">
                        <ul>
                          <li>
                            <p>Plot Size</p>
                            2m x 2m/4 sq. meters
                          </li>
                          <li>
                            <p>Plot Number</p>
                            54876
                          </li>
                          <li>
                            <p>Phase</p>
                            PI
                          </li>
                          <li>
                            <p>Subphase</p>
                            PM
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <p>Category</p>
                            Burial Plots
                          </li>
                          <li>
                            <p>Type</p>
                            Bank Transfer
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg="4" className="right-side p-3">
                <h3 className="d-flex align-center gap-2">
                  Kendal{" "}
                </h3>
                <div className="customer-info d-flex align-items-center gap-2">
                  <div className="profile">
                    <img src={profile} alt="image" />
                  </div>
                  <div>
                    <h4>Esther Howard</h4>
                    <span><b>Registered on:</b> 11 May, 2025 10:12 am</span>
                  </div>
                </div>
                <label>Contact info</label>
                <ul>
                  <li><img src={mailIcon} alt="icon"/> estherhoward@domain.com</li>
                  <li><img src={callIcon} alt="icon"/> 01632 960787</li>
                </ul>
                <div className="select-buyer">
                  <button className="first">Buyer 1 <span>*</span></button>
                  <button>Buyer 2 (optional)</button>
                </div>
                <ul>
                  <li><img src={proIcon} alt="icon"/> Ester Howard</li>
                  <li><img src={addressIcon} alt="icon"/> 1901 Thornridge Cir. Shiloh, Hawaii 81063</li>
                  <li><img src={pinIcon} alt="icon"/> 160061</li>
                  <li><img src={callIcon} alt="icon"/> 01632 960787</li>
                  <li><img src={mailIcon} alt="icon"/> abc@gmail.com</li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default LockedPlotDetails;
